import * as Yup from 'yup';

export const ABOUT_SCHOOL_VALIDATION_SCHEMA = Yup.object().shape({
  mainText: Yup.string().required('Обязательное поле').max(500, 'Превышено максимальное число символов'),
  motivationalText: Yup.string().required('Обязательное поле').max(500, 'Превышено максимальное число символов'),
});
